<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-3">
            <yt-fw-date-picker-popup name="txtOdDatuma" formControlName="OdDatuma"
                [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}" [Label]="'KEP.ODDATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                <span *ngFor="let validation of errorMessages.OdDatuma">
                    <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
        <div class="col-md-3">
            <yt-fw-date-picker-popup name="txtDoDatuma" formControlName="DoDatuma"
                [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}" [Label]="'KEP.DODATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                <span *ngFor="let validation of errorMessages.DoDatuma">
                    <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-6">
            <button type="button" class="btn btn-primary" (click)="LoadPDF()">
                <span class="fa fa-fw fa-print"></span>
                Štampaj
            </button>
        </div>

    </div>

</form>